import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState = {
    tests: [],
    isLoading: true,
    error: null,
};

const testsByIdSlice = createSlice({
    name: "tests",
    initialState,
    reducers: {
        setTestsById: (state, action) => {
            state.tests = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action:PayloadAction<{isLoading:boolean}>) => {
            state.isLoading = action.payload.isLoading;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setTestsById, setLoading, setError } = testsByIdSlice.actions;

export const testsByIdReducer = testsByIdSlice.reducer;
